export const LOAD = 'status/LOAD';
export const LOAD_COMPLETED = 'status/LOAD_COMPLETED';
export const LOAD_FAILED = 'status/LOAD_FAILED';
